/**
 * [mojdzial1006, paczka MD-KIT → właściciel MD-WNIOSKI, projekt §2.2, §3.2, §3.3] REJESTR — GRUPA „WNIOSKI”.
 *
 * Dwa miejsca: „Wnioski zespołu” (`/moj-dzial/wnioski` — jedno miejsce decyzji o wnioskach ludzi; decyzja zapada wyłącznie
 * w karcie wniosku, ZM-25) i „Moje sprawy” (`/moj-dzial/wnioski-przelozonego` — zlecenia z kadr, umowy zespołu, własne wnioski).
 * Etykieta grupy („Wnioski”) ≠ etykieta miejsca („Wnioski zespołu”) — Z-12. `komponent` = zaślepki z MD-KIT.
 */
import { GRUPY_MOJEGO_DZIALU, kreatoryMiejsca, miejsceZZakladki, obiektyMiejsca } from "./wspolne";

export const miejsceWnioski = miejsceZZakladki("wnioski", {
    grupa: GRUPY_MOJEGO_DZIALU.wnioski,
    etykieta: "Wnioski zespołu",
    zdanie: "Tu decydujesz o wnioskach ludzi, za których odpowiadasz.",
    wzor: "S2",
    licznik: true,
    widoki: [
        { id: "do-decyzji", etykieta: "Do mojej decyzji", licznik: true },
        { id: "w-toku", etykieta: "W toku", licznik: true },
        { id: "zakonczone", etykieta: "Zakończone" },
        { id: "wszystkie", etykieta: "Wszystkie" },
    ],
    filtry: ["kto", "typ", "stan", "jednostka"],
    obiekty: obiektyMiejsca("wniosek", "raport"),
    kreatory: kreatoryMiejsca("wniosek-w-imieniu"),
    pasek: { szukajka: "Szukaj wniosku…", akcjaGlowna: "Wniosek w imieniu…", wiecej: ["Pobierz listę (CSV)…", "Przejdź do Obsługi HR →"] },
    glowa: { zdanieStanu: "sprawdzono o 08:12 · 12 czeka w Dziale Kadr" },
    zdarzeniaNaZywo: ["hr-notification", "hr-request-changed", "hr-comment-added"],
    dziennikWejscia: "MyDeptRequestsPage",
    slowa: ["wnioski", "akceptacja", "do decyzji", "zatwierdź wniosek", "odrzuć", "korekta", "wniosek w imieniu", "urlop"],
    komponent: () => import("../../../pages/mojDzial/miejsca/WnioskiZespolu"),
});

export const miejsceMojeSprawy = miejsceZZakladki("wnioski-przelozonego", {
    grupa: GRUPY_MOJEGO_DZIALU.wnioski,
    etykieta: "Moje sprawy",
    zdanie: "Twoje sprawy przełożonego: zlecenia z kadr, umowy zespołu i Twoje wnioski.",
    wzor: "S2",
    licznik: true,
    widoki: [
        { id: "do-zrobienia", etykieta: "Do zrobienia", licznik: true },
        { id: "umowy", etykieta: "Umowy", licznik: true },
        { id: "moje-wnioski", etykieta: "Moje wnioski" },
        { id: "wszystkie", etykieta: "Wszystkie" },
    ],
    filtry: ["stan", "rodzaj", "kto", "jednostka"],
    obiekty: obiektyMiejsca("zlecenie", "wniosek"),
    kreatory: kreatoryMiejsca("wniosek-wlasny"),
    pasek: { szukajka: "Szukaj sprawy…", akcjaGlowna: "Złóż mój wniosek…", wiecej: ["Wniosek w imieniu…", "Pobierz listę (CSV)…"] },
    glowa: { zdanieStanu: "Złożone 12 · czeka 3 · zatwierdzone 8 · odrzucone 1" },
    sekcje: [{ id: "rozliczenia", etykieta: "Rozliczenia delegacji zespołu" }],
    zdarzeniaNaZywo: ["hr-notification", "hr-request-changed"],
    dziennikWejscia: "MyDeptManagerRequestsPage",
    slowa: ["moje do wypełnienia", "zlecenia z kadr", "umowy", "moje wnioski", "rozliczenia delegacji", "wnioski przełożonego"],
    komponent: () => import("../../../pages/mojDzial/miejsca/MojeSprawy"),
});

export const miejscaWnioskow = [miejsceWnioski, miejsceMojeSprawy];

export default miejscaWnioskow;
